import React from "react";
import { useQuery } from "react-query";
import { ordersData } from "../../components/globalApi/Api.js";
import html2pdf from "html2pdf.js";
import { useLocation } from "react-router-dom";

const ProductOutInvoice = () => {
  const { state } = useLocation();
  console.log("state", state);
  const detailsCompany = localStorage.getItem("companyDetails");
  const companyDetails = detailsCompany ? JSON.parse(detailsCompany) : null;

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "ordersData",
    ordersData,
    {
      refetchOnWindowFocus: false,
    }
  );

  let details = (data && data?.data) || [];

  // Filter orders by executive and salesDate (salesDate expected as YYYY-MM-DD)
  const selectedDateStr = state?.salesDate || new Date().toISOString().split("T")[0];

  let productDetails = details
    ?.filter((data) => {
      if (!data?.salesDate) return false;
      const orderDateStr = new Date(data.salesDate).toISOString().split("T")[0];
      return (
        data?.executiveName === state?.executiveName && orderDateStr === selectedDateStr
      );
    })
    .flatMap((data) => data?.orderProducts || []);

  // ✅ Group products only by product name (ignore ID)
  const groupedProducts = productDetails?.reduce((acc, item) => {
    const key = item?.product; // group by product name only
    if (!acc[key]) {
      acc[key] = { ...item };
    } else {
      acc[key].quantity += item?.quantity || 0;
    }
    return acc;
  }, {});

  const finalProducts = Object.values(groupedProducts || {});

  const handleDownload = () => {
    const element = document.getElementById("invoicePage");
    const opt = {
      margin: 0.5, // top, left, bottom, right
      filename: `Product-Out.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0, // avoid cut issues
      },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // allow auto page breaks
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <>
      <div className="invoce_main_block">
        <div className="invoice_sub_block">
          <div id="invoicePage">
            <div className="table-responsive invoice_table_block">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      colSpan="2"
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      {companyDetails?.shopName || null}
                      <br />
                      {`${companyDetails?.companyAddress || ""} , ${
                        companyDetails?.companyLocation || ""
                      }`}
                      <br />
                      {`${companyDetails?.district || ""} ,${
                        companyDetails?.companyPincode || ""
                      }`}
                      <br />
                      {"TAMILNADU"}
                    </th>
                    <th
                      className="invoice_table_heading"
                      style={{ textAlign: "left" }}
                    >
                      Executive : {state?.executiveName || null}
                      <br />
                      Sales Date : {selectedDateStr || null}
                      <br />
                    </th>
                  </tr>
                  <tr>
                    <th className="invoice_table_heading">S.No</th>
                    <th className="invoice_table_heading">Product Name</th>
                    <th className="invoice_table_heading">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {finalProducts && finalProducts?.length > 0 ? (
                    finalProducts?.map((item, i) => (
                      <tr key={i}>
                        <td className="invoice_table_data">{i + 1 || "-"}</td>
                        <td className="invoice_table_data">
                          {item?.product || "-"}
                        </td>
                        <td className="invoice_table_data">
                          {item?.quantity || "-"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        className="invoice_table_data"
                        style={{ textAlign: "center" }}
                      >
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="row my-3">
          <div className="col-lg-12">
            <button
              className="invoice_download_button"
              type="button"
              onClick={handleDownload}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductOutInvoice;
